<template>
  <div class="bto-sb-widget bto-sb-widget-search"
    :class="{
      'bto-sb-widget-search-load': searchInProgress,
      'bto-sb-current-shown-widget': searchIsExpanded,
      }"
    @mouseenter="focusSearchField"
    ref="widgetSearch">
    <input type="text"
      :placeholder="t('Mobile.Search')"
      class="bto-sb-form-input"
      ref="btosbsearch"
      v-model="searchQuery" >
    <button type="submit" class="bto-sb-form-btn"></button>
    <search-results-component v-if="showResults" 
      :searchEvents="filteredEvents" 
      :searchTournaments="filteredTournaments" 
      @clearSearch="clearSearch" />
  </div>
</template>

<script>
  import SearchResultsComponent from './components/search-results-component';
  import SearchService from '../../../services/search-service';
  import SearchEventsModel from '../../../models/search-results/search-events.model';
  import SearchTournamentsModel from '../../../models/search-results/search-tournaments.model';

  export default {
    name: 'SearchMatchesWidget',
    data() {
      return {
        searchQuery: '',
        filteredEvents: [],
        filteredTournaments: [],
        rawEvents: [],
        rawTournamets: [],
        searchInProgress: false,
        searchService: null,
        searchIsExpanded: false,
      };
    },
    created() {
      this.searchService = new SearchService();
    },
    computed: {
      showResults() {
        if (+this.searchQuery) {
          return this.searchQuery.length >= 4;
        }
        return this.searchQuery.length >= 3;
      },
    },
    watch: {
      searchQuery(newQuery, oldQuery) {
        if (!newQuery) {
          this.rawEvents = [];
          this.rawTournamets = [];
          return;
        }
        const isNumber = +this.searchQuery;
        if ((newQuery.length > 3 && oldQuery.length && !isNumber) || newQuery.includes(oldQuery)) {
          this.filteredTournaments = this.filterResults(newQuery, this.rawTournamets, 'tournamentName');
          this.filteredEvents = this.filterResults(newQuery, this.rawEvents, 'searchField');
        }
        if ((newQuery.length === 3 && newQuery !== oldQuery && !isNumber) ||
          (newQuery.length >= 3 && !oldQuery.length) || (newQuery.length >= 4 && isNumber)) {
          this.matchSearch();
        }
      },
    },
    methods: {
      matchSearch() {
        if (this.$refs.widgetSearch) {
          this.searchIsExpanded = this.$refs.widgetSearch.classList.contains('bto-sb-current-shown-widget');
        }
        this.searchService.getParams.searchTerm = this.searchQuery;
        this.searchInProgress = true;
        this.searchService.execute((resp) => {
          // map the results to the model
          const rawEvents = (resp && resp.data && resp.data.Events) || [];
          const rawTournamets = (resp && resp.data && resp.data.Tournaments) || [];
          this.rawTournamets = rawTournamets.map(t => new SearchTournamentsModel(t));
          this.rawEvents = rawEvents.map(event => new SearchEventsModel(event));

          let isNumber = +this.searchQuery;
          if (this.searchQuery.length > 3 && !isNumber) {
            this.filteredTournaments = this.filterResults(this.searchQuery, this.rawTournamets, 'tournamentName');
            this.filteredEvents = this.filterResults(this.searchQuery, this.rawEvents, 'searchField');
          } else {
            this.filteredTournaments = this.rawTournamets;
            this.filteredEvents = this.rawEvents;
          }
          this.searchInProgress = false;
        });
      },
      filterResults(term, arr = [], filterKey = '') {
        return arr.filter(result => result[filterKey].toLowerCase().indexOf(term.toLowerCase()) > -1);
      },
      clearSearch(openMatchDetails) {
        this.searchQuery = '';
        this.filteredEvents = [];
        this.rawEvents = [];
        this.filteredTournaments = [];
        this.rawTournamets = [];
        if (!openMatchDetails) {
          this.focusSearchField();
        } else {
          this.searchIsExpanded = false;
        }
      },
      focusSearchField() {
        if (typeof this.$refs.btosbsearch !== 'undefined') {
          this.$refs.btosbsearch.focus();
        }
      },
    },
    components: {
      SearchResultsComponent,
    }
  };
</script>
